import React from "react";
import { View, ViewStyle } from "react-native";
import { AppText } from "@/components/ui/AppText";
import { cn } from "@/lib/utils";

export interface StatCardProps {
  title: string;
  value: string | number;
  description?: string;
  icon: React.ReactNode;
  iconBgClass?: string;
  style?: ViewStyle;
  className?: string;
}

/**
 * A reusable card for displaying a single metric (e.g. "Applications Submitted").
 */
export function StatCard({
  title,
  value,
  description,
  icon,
  iconBgClass = "bg-stroke-30",
  style,
  className,
}: StatCardProps) {
  return (
    <View
      className={cn(
        "flex-col items-start px-6 py-5 rounded-md border border-stroke-50 bg-white overflow-hidden min-w-[280px] flex-1",
        className
      )}
      style={style}
      testID="stat-card"
    >
      <View className="gap-3 w-full">
        <View className="flex-row items-start gap-2.5">
          <View className="flex-1 flex-col items-start gap-3">
            <AppText weight="medium" className="text-supporting-text text-base leading-[1.4]">
              {title}
            </AppText>
            <AppText
              weight="semibold"
              className="text-dark-text-50 text-2xl leading-[1.2] tracking-tight"
            >
              {value}
            </AppText>
          </View>
          <View className={`rounded-md p-2 items-center justify-center w-10 h-10 ${iconBgClass}`}>
            {icon}
          </View>
        </View>
        {description && <AppText className="text-sm text-dark-text-20">{description}</AppText>}
      </View>
    </View>
  );
}
